import React, { useEffect, useRef, useState } from 'react';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { endPoints } from '../../../Config';
import { Button } from 'primereact/button';
import * as Yup from 'yup';
import { InputText } from 'primereact/inputtext';
import { useLocation, useNavigate } from 'react-router-dom';
import { handleGetRequest } from '../../../service/GetTemplate';
import { handlePatchRequest } from '../../../service/PatchTemplate';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';

const EditMerchantApproval = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [form29File, setForm29File] = useState(null);
    const [ntnNumberFile, setNtnNumberFile] = useState(null);
    const [idCardFrontFile, setIdCardFrontFile] = useState(null);
    const [idCardBackFile, setIdCardBackFile] = useState(null);
    const [ownerPictureFile, setOwnerPictureFile] = useState(null);
    const [form29FileLink, setForm29FileLink] = useState(null);
    const [ntnNumberFileLink, setNtnNumberFileLink] = useState(null);
    const [idCardFrontFileLink, setIdCardFrontFileLink] = useState(null);
    const [idCardBackFileLink, setIdCardBackFileLink] = useState(null);
    const [ownerPictureFileLink, setOwnerPictureFileLink] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { rowData } = location.state || {};

    const actionOptions = [
        { name: 'Approved', id: true },
        { name: 'Reject', id: false }
    ];
    // const user = JSON.parse(localStorage.getItem('user') || '{}');

    const validationSchema = Yup.object().shape({
        isApproved: Yup.string().required('This field is required'),

        comment: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
    });

    const stateSetters = {
        OwnerPicture: setOwnerPictureFile,
        Form29: setForm29File,
        NTNNumber: setNtnNumberFile,
        IDCardFront: setIdCardFrontFile,
        IDCardBack: setIdCardBackFile
    };

    const dispatch = useDispatch();

    const ownerPictureRef = useRef(null);
    const form29ImageRef = useRef(null);
    const ntnImageRef = useRef(null);
    const cnicFrontImageRef = useRef(null);
    const cnicBackImageRef = useRef(null);

    const handleFileChange = (event, fieldKey) => {
        const selectedFile = event.target.files[0];

        formik.setFieldValue(fieldKey, selectedFile?.name);
        stateSetters[fieldKey](selectedFile);
    };

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            id: '',
            POCName: '',
            POCEmail: '',
            CompanyName: '',
            CompanyEmail: '',
            OwnerPicture: '',
            CompanyWebsite: '',
            POCPhone: '',
            Form29: '',
            NTNNumber: '',
            IDCardFront: '',
            IDCardBack: '',
            comment: '',
            isApproved: '',
            CreatedBy: ''
        },

        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('adminUser') || '{}');
            setLoadingBtn(true);

            const requestData = {
                isApproved: data?.isApproved,
                merchantId: rowData?.id,
                modifiedBy: user?.data?.userId || '',
                comment: data?.comment
            };

            const response = await dispatch(handlePatchRequest(requestData, endPoints.merchantApproval, true));
            if (response?.status === 200) {
                formik.resetForm();
                // onHide();
            }
            setLoadingBtn(false);
        }
    });
    const downloadFile = (file, fileName) => {
        if (!file) return;
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName || 'download';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    const fileLinkDownload = (fileLink) => {
        if (!fileLink) return;
        const a = document.createElement('a');
        a.href = fileLink;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const getMerchantbyId = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getMerchantById(rowData.id), true);
        console.log('response', response);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('status', response?.data?.status);
            formik.setFieldValue('POCName', response?.data?.pocName);
            formik.setFieldValue('POCEmail', response?.data?.pocEmail);
            formik.setFieldValue('ownerPassword', response?.data?.ownerPassword);
            formik.setFieldValue('CompanyName', response?.data?.companyName);
            formik.setFieldValue('CompanyEmail', response?.data?.companyEmail);
            formik.setFieldValue('CompanyWebsite', response?.data?.companyWebsiteLink);
            formik.setFieldValue('POCPhone', response?.data?.pocContactNumber);
            formik.setFieldValue('Form29', response?.data?.form29);
            formik.setFieldValue('NTNNumber', response?.data?.ntnNumber);
            formik.setFieldValue('IDCardFront', response?.data?.idCardFront);
            formik.setFieldValue('IDCardBack', response?.data?.idCardBack);
            formik.setFieldValue('OwnerPicture', response?.data?.ownerPicture);
            setForm29FileLink(response?.data?.form29);
            setIdCardBackFileLink(response?.data?.idCardBack);
            setIdCardFrontFileLink(response?.data?.idCardFront);
            setOwnerPictureFileLink(response?.data?.ownerPicture);
            setNtnNumberFileLink(response?.data?.ntnNumber);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        getMerchantbyId();
    }, [rowData]);

    const imageBoxStyle = {
        width: '150px',
        height: '150px',
        border: '1px solid #dcdcdc',
        borderRadius: '6px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9f9f9'
    };

    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    };


    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="p-4">
                <div className="flex justify-content-between align-items-center mb-3">
                    <h3>Approve Merchant</h3>
                </div>
                <div className="grid p-fluid">
                    <div className="col-12 md:col-12 border-bottom-1 mb-2 font-semibold">POC Info</div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="POCName">POC Name</label>
                            <InputText id="POCName" name="POCName" placeholder="Enter Owner Name" value={formik?.values?.POCName} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.POCName && formik.errors.POCName && <small className="p-error">{formik.errors.POCName}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="POCEmail">POC Email</label>
                            <InputText id="POCEmail" name="POCEmail" placeholder="Enter Owner Email" value={formik?.values?.POCEmail} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.POCEmail && formik.errors.POCEmail && <small className="p-error">{formik.errors.POCEmail}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="POCPhone">POC Phone</label>
                            <InputText id="POCPhone" name="POCPhone" placeholder="Enter Owner Phone" value={formik?.values?.POCPhone} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.POCPhone && formik.errors.POCPhone && <small className="p-error">{formik.errors.POCPhone}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-12 border-bottom-1 mb-2 font-semibold">Company Info</div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="CompanyName">Company Name</label>
                            <InputText id="CompanyName" name="CompanyName" placeholder="Enter Company Name" value={formik?.values?.CompanyName} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.CompanyName && formik.errors.CompanyName && <small className="p-error">{formik.errors.CompanyName}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="CompanyEmail">Company Email</label>
                            <InputText id="CompanyEmail" name="CompanyEmail" placeholder="Enter Company Email" value={formik?.values?.CompanyEmail} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.CompanyEmail && formik.errors.CompanyEmail && <small className="p-error">{formik.errors.CompanyEmail}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="CompanyWebsite">Company Website</label>
                            <InputText id="CompanyWebsite" name="CompanyWebsite" placeholder="Enter Company Website" value={formik?.values?.CompanyWebsite} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.CompanyWebsite && formik.errors.CompanyWebsite && <small className="p-error">{formik.errors.CompanyWebsite}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload Form 29</label>
                                <div className="flex justify-content-center align-items-center">
                                    {form29FileLink ? (
                                        <div style={imageBoxStyle}>
                                            <img src={form29FileLink} alt="Form 29" style={imageStyle} />
                                        </div>
                                    ) : (
                                        <small>No Image</small>
                                    )}
                                </div>
                                {/* <div className="file-input-container file-input-wrapper w-100">
                                    <input type="file" accept="image/*" style={{ display: 'none' }} className="file-input-field" disabled />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.Form29} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.Form29 && formik.errors.Form29 ? <small className="p-error">{formik.errors.Form29}</small> : ''} */}
                            </div>
                        </div>


                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button icon="pi pi-arrow-down" tooltip="Download File" rounded aria-label="Download" onClick={() => fileLinkDownload(form29FileLink)} disabled={!form29File && !formik?.values?.Form29} />
                        </div>
                    </div> */}
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload NTN Number</label>
                                <div className="flex justify-content-center align-items-center">
                                    {ntnNumberFileLink ? (
                                        <div style={imageBoxStyle}>
                                            <img src={ntnNumberFileLink} alt="NTN Number" style={imageStyle} />
                                        </div>
                                    ) : (
                                        <small>No Image</small>
                                    )}
                                </div>
                                {/* <div className="file-input-container file-input-wrapper w-100">
                                    <input type="file" accept="image/*" style={{ display: 'none' }} disabled className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.NTNNumber} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.NTNNumber && formik.errors.NTNNumber ? <small className="p-error">{formik.errors.NTNNumber}</small> : ''} */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button
                                icon="pi pi-arrow-down"
                                rounded
                                aria-label="Download NTN"
                                onClick={() => {
                                    fileLinkDownload(idCardFrontFileLink);
                                }}
                                disabled={!ntnNumberFile && !formik?.values?.NTNNumber}
                                tooltip="Download File"
                            />
                        </div>
                    </div> */}
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload CNIC Front</label>
                                <div className="flex justify-content-center align-items-center">
                                    {idCardFrontFileLink ? (
                                        <div style={imageBoxStyle}>
                                            <img src={idCardFrontFileLink} alt="ID Card Front" style={imageStyle} />
                                        </div>
                                    ) : (
                                        <small>No Image</small>
                                    )}
                                </div>
                                {/* <div className="file-input-container file-input-wrapper w-100">
                                    <input type="file" accept="image/*" style={{ display: 'none' }} disabled className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.IDCardFront} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.IDCardFront && formik.errors.IDCardFront ? <small className="p-error">{formik.errors.IDCardFront}</small> : ''} */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button
                                icon="pi pi-arrow-down"
                                rounded
                                aria-label="Download CNIC Front"
                                onClick={() => downloadFile(idCardFrontFile, formik?.values?.IDCardFront)}
                                disabled={!idCardFrontFile && !formik?.values?.IDCardFront}
                                tooltip="Download File"
                            />
                        </div>
                    </div> */}
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload CNIC Back</label>
                                <div className="flex justify-content-center align-items-center">
                                    {idCardBackFileLink ? (
                                        <div style={imageBoxStyle}>
                                            <img src={idCardBackFileLink} alt="ID Card Back" style={imageStyle} />
                                        </div>
                                    ) : (
                                        <small>No Image</small>
                                    )}
                                </div>
                                {/* <div className="file-input-container file-input-wrapper w-100">
                                    <input type="file" accept="image/*" style={{ display: 'none' }} disabled className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.IDCardBack} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.IDCardBack && formik.errors.IDCardBack ? <small className="p-error">{formik.errors.IDCardBack}</small> : ''} */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button
                                icon="pi pi-arrow-down"
                                rounded
                                aria-label="Download CNIC Back"
                                onClick={() => {
                                    fileLinkDownload(idCardBackFileLink);
                                }}
                                disabled={!idCardBackFile && !formik?.values?.IDCardBack}
                                tooltip="Download File"
                            />
                        </div>
                    </div> */}
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload Picture</label>
                                <div className="flex justify-content-center align-items-center">
                                    {ownerPictureFileLink ? (
                                        <div style={imageBoxStyle}>
                                            <img src={ownerPictureFileLink} alt="Owner Picture" style={imageStyle} />
                                        </div>
                                    ) : ( 
                                        <small>No Image</small>
                                    )}
                                </div>
                                {/* <div className="file-input-container file-input-wrapper w-100">
                                    <input type="file" accept="image/*" style={{ display: 'none' }} disabled className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.OwnerPicture} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.OwnerPicture && formik.errors.OwnerPicture ? <small className="p-error">{formik.errors.OwnerPicture}</small> : ''} */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button
                                icon="pi pi-arrow-down"
                                rounded
                                aria-label="Download Owner Picture"
                                onClick={() => {
                                    fileLinkDownload(ownerPictureFileLink);
                                }}
                                disabled={!ownerPictureFile && !formik?.values?.OwnerPicture}
                                tooltip="Download File"
                            />
                        </div>
                    </div> */}
                    <div className="col-12 md:col-9">
                        
                    </div>
                    <div className="col-12 md:col-6">
                        <div className="field mb-3">
                            <label htmlFor="isApproved">
                                Action<span style={{ color: 'red' }}>*</span>
                            </label>
                            <Dropdown id="isApproved" name="isApproved" placeholder="Select Action" options={actionOptions} optionLabel="name" optionValue="id" value={formik?.values?.isApproved} onChange={formik.handleChange} />
                            {formik.touched.isApproved && formik.errors.isApproved && <small className="p-error">{formik.errors.isApproved}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-12">
                        <div className="field mb-3">
                            <label htmlFor="comment">
                                Remarks<span style={{ color: 'red' }}>*</span>
                            </label>
                            <InputTextarea id="comment" name="comment" placeholder="Enter Remarks" value={formik?.values?.comment} maxLength={100} onChange={formik.handleChange} />
                            {formik.touched.comment && formik.errors.comment && <small className="p-error">{formik.errors.comment}</small>}
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center mt-4 gap-2">
                    <Button label="Update" icon="pi pi-pencil" type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                    <Button label="Cancel" icon="pi pi-file-o" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => navigate('/merchant-approval-list')} />
                </div>
            </div>
        </form>
    );
};

export default EditMerchantApproval;
